import type { AssessmentQuestion } from '@entities/assessment'

import imgQuestion2 from '../../../../ui/images/questions/math/grade-k7/question-2.png'
import imgQuestion7 from '../../../../ui/images/questions/math/grade-k7/question-7.png'
import imgQuestion8 from '../../../../ui/images/questions/math/grade-k7/question-8.png'
import imgQuestion9 from '../../../../ui/images/questions/math/grade-k7/question-9.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k7_1',
    title: 'The ratio between 2 numbers is 7:8. If their LCM is 224, find the numbers.',
    topic: 'Ratio',
    answers: [
      {
        name: 'grade_k7_1_a',
        text: '6 and 8',
      },
      {
        name: 'grade_k7_1_b',
        text: '28 and 32',
        correct: true,
      },
      {
        name: 'grade_k7_1_c',
        text: '9 and 10',
      },
      {
        name: 'grade_k7_1_d',
        text: '15 and 20',
      },
    ],
  },
  {
    name: 'grade_k7_2',
    title: 'If x:y= 5:6 and y:z= 7:8, find x:y:z.',
    topic: 'Proportion',
    image: imgQuestion2,
    answers: [
      {
        name: 'grade_k7_2_a',
        text: '30:31:32',
      },
      {
        name: 'grade_k7_2_b',
        text: '42:52:62',
      },
      {
        name: 'grade_k7_2_c',
        text: '50:40:60',
      },
      {
        name: 'grade_k7_2_d',
        text: '35:42:48',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_3',
    title: 'Find out the rational number whose numerator is (-5) × 4 and the denominator is (25 - 16) × (8 - 5).',
    topic: 'Rational Numbers',
    answers: [
      {
        name: 'grade_k7_3_a',
        text: '-20/27',
        correct: true,
      },
      {
        name: 'grade_k7_3_b',
        text: '-27/20',
      },
      {
        name: 'grade_k7_3_c',
        text: '27/20',
      },
      {
        name: 'grade_k7_3_d',
        text: '20/27',
      },
    ],
  },
  {
    name: 'grade_k7_4',
    title: 'Find the expression equivalent to 5.3(x - 4) + 6.5(x +2).',
    topic: 'Expressions and Equations',
    answers: [
      {
        name: 'grade_k7_4_a',
        text: '11.8x - 8.2',
        correct: true,
      },
      {
        name: 'grade_k7_4_b',
        text: '10x - 8',
      },
      {
        name: 'grade_k7_4_c',
        text: '30x + 8',
      },
      {
        name: 'grade_k7_4_d',
        text: '15x - 15',
      },
    ],
  },
  {
    name: 'grade_k7_5',
    title: 'Toni got a taxi and paid $6.2 for 2 km. Then he got another taxi and paid $5.7 for 1.5 km. If the total distance is x and the total fare is y, which expression is appropriate to find out the total fare?',
    topic: 'Expressions and Equations',
    answers: [
      {
        name: 'grade_k7_5_a',
        text: 'X= 6.2(y -2) + 5.7(y - 1.5)',
      },
      {
        name: 'grade_k7_5_b',
        text: 'Y= 6.2(y -2) + 5.7(x - 1.5)',
      },
      {
        name: 'grade_k7_5_c',
        text: 'Y= 6.2(x -2) + 5.7(x - 1.5)',
        correct: true,
      },
      {
        name: 'grade_k7_5_d',
        text: 'Y= 6.2(x -2) + 5.7(y - 1.5)',
      },
    ],
  },
  {
    name: 'grade_k7_6',
    title: 'Dale bought a saucepan on sale for 30% off. She saved $6.75 from the original price. Find out the original price.',
    topic: 'Percent and Proportional Relationship',
    answers: [
      {
        name: 'grade_k7_6_a',
        text: '$30',
      },
      {
        name: 'grade_k7_6_b',
        text: '$35',
      },
      {
        name: 'grade_k7_6_c',
        text: '$22.5',
        correct: true,
      },
      {
        name: 'grade_k7_6_d',
        text: '$20',
      },
    ],
  },
  {
    name: 'grade_k7_7',
    title: 'The table here shows the relationship between teenagers and adults in a college. Which expression shows the proportional relationship between teenagers and adults?',
    topic: 'Percent and Proportional Relationship',
    image: imgQuestion7,
    answers: [
      {
        name: 'grade_k7_7_a',
        text: 'A=T',
      },
      {
        name: 'grade_k7_7_b',
        text: 'A= 1/2 T',
      },
      {
        name: 'grade_k7_7_c',
        text: 'T= 2/4 A',
      },
      {
        name: 'grade_k7_7_d',
        text: 'A= 1/4 T',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k7_8',
    title: 'Follow the grid and calculate the cost of 3 pounds of sugar.',
    topic: 'Statistics',
    image: imgQuestion8,
    answers: [
      {
        name: 'grade_k7_8_a',
        text: '$5',
      },
      {
        name: 'grade_k7_8_b',
        text: '$10',
        correct: true,
      },
      {
        name: 'grade_k7_8_c',
        text: '$7',
      },
      {
        name: 'grade_k7_8_d',
        text: '$8',
      },
    ],
  },
  {
    name: 'grade_k7_9',
    title: 'Determine the average score of students based on their test results.',
    topic: 'Statistics and Probability',
    image: imgQuestion9,
    answers: [
      {
        name: 'grade_k7_9_a',
        text: '72',
        correct: true,
      },
      {
        name: 'grade_k7_9_b',
        text: '65',
      },
      {
        name: 'grade_k7_9_c',
        text: '68',
      },
      {
        name: 'grade_k7_9_d',
        text: '70',
      },
    ],
  },
  {
    name: 'grade_k7_10',
    title: 'A bank rented safety deposit boxes. The measurements of a box: L= 22 in, W= 5 in, and H= 5 in. Calculate the volume of the box.',
    topic: 'Geometry',
    answers: [
      {
        name: 'grade_k7_10_a',
        text: '220 cubic inches',
      },
      {
        name: 'grade_k7_10_b',
        text: '550 cubic inches',
        correct: true,
      },
      {
        name: 'grade_k7_10_c',
        text: '490 cubic inches',
      },
      {
        name: 'grade_k7_10_d',
        text: '360 cubic inches',
      },
    ],
  },
]
